module.exports = __webpack_public_path__ + "static/media/map.ac5fca38.png";